
import { defineComponent, PropType } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';
import { MembersProfilesUpdateModel } from '@/modules/organizations/types'

export default defineComponent({
    name: 'show-update-members-response-dialog',
    props: {
        response: {
            type: Array as PropType<MembersProfilesUpdateModel[]>,
            required: true
        }
    },
    setup () {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

        const responseColumns = ([
            { name: 'rowNumber', label: 'Row number', field: (row: MembersProfilesUpdateModel) => row.rowNumber - 1, align: 'left' },
            { name: 'email', label: 'Email', field: 'email', align: 'left' },
            { name: 'message', label: 'Error message', field: 'message', align: 'left' }
        ])

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            responseColumns
        }
    }
})
